 /*
  --------------------
Sector ↑ and rank ↑
→ fresh leadership

Sector ↑ but rank ↓
→ losing momentum

Sector ↓ but rank ↑
→ defensive rotation

Sector ↓ and rank ↓
→ avoid

--------------------
  */

import React, {useEffect, useMemo, useRef, useState} from 'react';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
} from 'chart.js';

import { Line } from 'react-chartjs-2';
import { useDispatch, useSelector } from 'react-redux';
import { data, useNavigate } from 'react-router-dom';
import { getComboRotation, getDeliveryPercentList, getGoogleSheet, getIndicesActivity, getLeadingSectors, getSectorRotation, getStockDetails, getSymbolList, saveLeadingSectors } from '../action/api-services';
import PageLoader from '../component/loader';
import { normalize } from '../utils/utilsFunctions';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { AIPromptForStock1, NSE_Current_date } from '../utils/constants';
import chartIcon from '../assets/images/chart2.png';
import StockDetails from '../component/stockDetails';
import StockAction from '../component/stockAction';
import DeliveryGraph from '../component/deliveryGraph';
import { setDeliveryDataReducer } from "../redux/slice/deliveryData";
import SectorPanchang from '../component/sectorPanchag';


const rightLabelPlugin = {id: 'rightLabelPlugin', afterDatasetsDraw(chart){
        const {ctx, chartArea} = chart;
        const hovered = chart.$hoveredDataset;
        // const labelCount = chart.data.datasets.length;

        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const meta = chart.getDatasetMeta(datasetIndex);

            // console.log(meta);

            if(!meta?.data?.length){
                return;
            }
            const last = meta.data[meta.data.length - 1];
                  if(!last){return;}
            const active = hovered === datasetIndex;
            
            ctx.save();
            ctx.fillStyle = active ? dataset.backgroundColor : 'rgba(0,0,0,0)' ;
            // ctx.fillStyle = 'rgba(218, 0, 0, 1)' ;
            ctx.font = active? '700 16px Arial':'400 12px Arial';
            ctx.textBaseline = 'middle';
            ctx.fillText(dataset.label, chartArea.right + 35, last.y);
            ctx.restore();
        });
      }
};


ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  // rightLabelPlugin
);

export default function SectorRotation() {
      const dispatch = useDispatch();
      const [loader, setLoader] = useState(false);
      const [viewType, setViewType] = useState('combo');
      const [dataView, setDataView] = useState('2weekly');
      const [series, setSeries] = useState('IND INDICES');
      const [sectors, setSectors] = useState([]);
      const [getNiftyList, setNiftyList] = useState([]);
      const [getSectorsList, setSectorsList] = useState([]);
      const [selectedSectorsName, setSelectedSectorsName] = useState('Select');
      const [getStocksDetails, setStocksDetails] = useState([]);

      const [selectedSector, setSelectedSector] = useState({});
      const [hoveredSymbol, setHoveredSymbol] = useState('');
      const [viewStatistics, setViewStatistics] = useState('change_per'); // price | change_per
      const [symbolData, setSymbolData] = useState([]);
      const [todayData, setTodayData] = useState([]);
      const [todayTime, setTodayTime] = useState();
      const [niftyBeats, setNiftyBeats] = useState(0);
      const [leadingSectors, setLeadingSectors] = useState([]);
      const [leadingSectorsList, setLeadingSectorsList] = useState([]);
      const [leadingDropShow, setLeadingDropShow] = useState(false);
      const [durationDays, setDurationDays] = useState();


      


      const [startDate, setStartDate] = useState(moment(todayTime).format('YYYY-MM-DD'));
      const [getMaxDate, setMaxDate] = useState(moment(todayTime).format('YYYY-MM-DD'));
      const [getDeliveryDate, setDeliveryDate] = useState(moment(todayTime).format('YYYY-MM-DD'));

      useEffect(() => {
          if (todayTime) {
              setStartDate(moment(todayTime).format('YYYY-MM-DD'));
              setMaxDate(moment(todayTime).format('YYYY-MM-DD'));
              setDeliveryDate(moment(todayTime).format('YYYY-MM-DD'));
          }
      }, [todayTime]);



      useEffect(() => {
        if (leadingSectors) {

            const groupedLeadingSectors = Object.values(
                leadingSectors.reduce((groups, item) => {

                    if (!groups[item.date]) {
                        groups[item.date] = [];
                    }

                    groups[item.date].push(item);

                    return groups;
                }, {})
            )
            .map(group => {
                // Sort rotationScore high → low within each date
                return group.sort(
                    (a, b) =>
                        Number(b.rotationScore || 0) -
                        Number(a.rotationScore || 0)
                );
            })
            .sort((a, b) => {
                // Sort date newest → oldest
                return (
                    moment(b[0].date).valueOf() -
                    moment(a[0].date).valueOf()
                );
            });

            setLeadingSectorsList(groupedLeadingSectors);
        }
      }, [leadingSectors]);

      const userToken = useSelector(state => state.userToken.value);
      const navigate = useNavigate();
      const chartRef = useRef(null);


      const isWeekdayAllowed = (date) => {
          const day = date.getDay();    
          return day !== 0 && day !== 6; // Exclude weekends and holidays
          // return day !== 0 && day !== 6 && !YearHolidays.includes(excludeDate);
      };


      const generateColor = (index) => {
              const hue =  (index * 137.508) % 360;
              const saturation = 70 + (index % 20);
              const lightness = 45 + (index % 10);
              return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
            };
      


  /*
  --------------------
  FETCH
  --------------------
  */

  useEffect(() => {
      if (!userToken) {
          navigate('/');
          return;
      }
      setHoveredSymbol('');   
      setLoader(true);

      getGoogleSheet("", userToken).then((res) => {
            setTodayData(res?.data?.data.json_data || []);
            setTodayTime(res?.data?.data.datetime);
      })
      .catch(console.error) 
      
      
      getSymbolList('EQ', '', userToken).then((res) => {
            setSymbolData(res.data.data || []);
      })
      .catch(console.error) 

      getLeadingSectors(userToken).then((res) => {
          setLeadingSectors(res.data.data || []);
      })
      .catch(console.error);



      

      getIndicesActivity({type: dataView, series, indice: 'NIFTY_50', date: moment(startDate).format('YYYY-MM-DD')}, userToken).then((res) => {
            setNiftyList(res?.data?.data || []);
            setDeliveryDate(Object.keys(res?.data?.data[0]?.stock_data || {})[0]);
      })
      .catch(console.error)        


      if(viewType === 'indices' && selectedSectorsName === 'Select'){
            getIndicesActivity({type: dataView, series, date: moment(startDate).format('YYYY-MM-DD')}, userToken).then((res) => {        
                 setSectors(res?.data?.data || []);
                 if(selectedSectorsName === 'Select'){
                        setSectorsList(res?.data?.data || []);
                 }
            })
            .catch(console.error)        
            .finally(() => {        
                setLoader(false);
            });
            
      }else if(viewType === 'combo' && selectedSectorsName === 'Select'){
            
              getComboRotation({type: dataView, series: 'EQ', date: moment(startDate).format('YYYY-MM-DD'), sector: selectedSectorsName !== 'Select'? selectedSectorsName: ''}, userToken).then(res => {
                      setSectors(res?.data?.data || []);
                      if(selectedSectorsName === 'Select'){
                          setSectorsList(res?.data?.data || []);
                      } 
              })
              .catch(console.error)
              .finally(() =>
                setLoader(false)
              );
      }else{
              getSectorRotation({type: dataView, series: 'EQ', date: moment(startDate).format('YYYY-MM-DD'), sector: selectedSectorsName !== 'Select'? selectedSectorsName: ''}, userToken).then(res => {
                      setSectors(res?.data?.data || []);
                      if(selectedSectorsName === 'Select'){
                          setSectorsList(res?.data?.data || []);
                      } 
              })
              .catch(console.error)
              .finally(() =>
                setLoader(false)
              );
      }


  }, [userToken, viewType, dataView, startDate]);


  
  const handleChangeViewType = (e) => {
        setViewType(e.target.value);
        setSelectedSectorsName('Select');
        setStocksDetails([]);
        if(e.target.value === 'indices'){
          setViewStatistics('change_per'); 
        }
  }

  const handleChangeDataType = (e) => {
        setDataView(e.target.value);
        setStocksDetails([]);
        // setSelectedSectorsName('');
  }

  

  const handerSelectSector = (getSector) => {
        setHoveredSymbol('');
        setSelectedSectorsName(getSector);
        setStocksDetails([]);
        if(getSector === "Select"){
              setSectors(getSectorsList);
              setViewStatistics('change_per'); // change_per | price
        }else{
          setLoader(true);
          setViewStatistics('price');
          setDataView('2weekly');
          getSectorRotation({type: dataView, series:'EQ', date: moment(startDate).format('YYYY-MM-DD'), sector: getSector}, userToken).then(res => {
                  setSectors(res?.data?.data || []);
                  setStocksDetails([]);
          })
          .catch(console.error)
          .finally(() =>
            setLoader(false)
          );   

           let current_date = moment(todayTime).format('DDMMYY');
           getDeliveryPercentList(current_date, 'sectors', getSector, '', 'EQ', 6, userToken).then(res => {
            dispatch(setDeliveryDataReducer(res?.data?.data || []));
          })
        } 
  }


  const handerStockDetails = (getStock) => {
      getStockDetails({date: moment(startDate).format('YYYY-MM-DD'), stock: getStock}, userToken).then(res => {
            setStocksDetails(res?.data?.data || [])
            

          const chart = chartRef.current;
          if (!chart) return;

          let selectedColor = "#555";
          let datasetIndex = 1;


          chart.data.datasets.forEach((ds, i) => {
              const isSelected = ds.symbol === getStock;
              if (isSelected) {
                  datasetIndex = ds.datasetIndex + 1
                  selectedColor = String( Array.isArray(ds.borderColor) ? ds.borderColor[0] : ds.borderColor  );
              }
              if(ds.symbol !== 'NIFTY_50'){
                    ds.borderWidth = isSelected ? 6 : 2;
                    ds.order = isSelected ? -999 : 1;
              }
              
              
          });
          chart.update();

      })
      .catch(console.error)
  }


  


  /*
  --------------------
  LABELS
  --------------------
  */

  const labels = useMemo(() => {
        const dates = new Set();
              sectors?.forEach(s => { 
                    Object.keys(s.stock_data || {}).forEach(d => dates.add(d));
                });
              return [
                      ...dates
                    ]
              .sort((a, b) => new Date(a) - new Date(b));
  
  }, [sectors]);


  useEffect(() =>{
    if(labels){
      setDurationDays(labels[0] + 'to' + labels[labels.length - 1]);
    }

  }, [labels])

  /*
  --------------------
  DATASETS
  --------------------
  */

  // Assuming first item in getNiftyList is NIFTY50 benchmark
const niftyBenchmark = labels.map((d, idx) => {

    const nifty = getNiftyList?.[0];
    if (!nifty) return 0;

    if (viewStatistics === 'price') {

        const firstPrice =
            Number(nifty.stock_data?.[labels.find(x => nifty.stock_data?.[x]?.close_price != null)]?.close_price) || 1;

        const current =
            Number(nifty.stock_data?.[d]?.close_price || firstPrice);

        return (((current - firstPrice) / firstPrice) * 100);

    } else {

        let value = 100;

        for (let i = 1; i <= idx; i++) {
            const ch = Number(nifty.stock_data?.[labels[i]]?.change_per || 0);
            value *= (1 + ch / 100);
        }

        return (((value - 100) / 100) * 100);
    }

});



  const datasets = useMemo(() => {
         const clamp = (v, min = -100, max = 100) =>  Math.max(min, Math.min(max, Number(v || 0)));
         const momentumValues = sectors.map(s => Number(s.momentum || 0));
         const minMomentum = Math.min(...momentumValues);
         const maxMomentum = Math.max(...momentumValues);

         return [...sectors].map((s, originalIndex) => {

              // historical sector performance
              const All_ttl_trd_qty = labels.map(d =>  s.stock_data?.[d]?.ttl_trd_qty);
              const All_no_of_trades = labels.map(d =>  s.stock_data?.[d]?.no_of_trades);
              const All_delivery_per = labels.map(d =>  s.stock_data?.[d]?.delivery_per);
              const All_close_price = labels.map(d =>  s.stock_data?.[d]?.close_price);
              const latestScore = Object.entries(s.stock_data || {}).at(-1)[1].score;
              const current_star = Object.entries(s.stock_data || {}).at(-1)[1].current_star;
              const close_price = Object.entries(s.stock_data || {}).at(-1)[1].close_price;
              const delivery_per = Object.entries(s.stock_data || {}).at(-1)[1].delivery_per;

              
              let raw = [];
              // For Real Change Per
              // if(viewStatistics === 'change_per'){
              //       raw = labels.map(d => {
              //                   const val = s.stock_data?.[d]?.change_per;
              //                   return val == null ? null : clamp(val);
              //       });
              // }

              // For average +-100%
              if (viewStatistics === 'change_per') {
                    let indexValue = 100;

                    const relativeSeries = labels.map((d, idx) => {
                        if (idx === 0) {
                            return 0;
                        }
                        const change = Number(s.stock_data?.[d]?.change_per ?? 0);
                        // compounded movement
                        indexValue *= (1 + change / 100);
                        return (((indexValue - 100) / 100) * 100);
                    });

                    // find largest movement
                      const maxAbsMove = Math.max(
                          ...relativeSeries
                              .filter(v => v != null)
                              .map(v => Math.abs(v)),
                          1
                      );

                      // normalize to hierarchy
                      raw = relativeSeries.map(v => {
                          if (v == null) {
                              return null;
                          }
                          return Number(Math.max(-100, Math.min(100, (v / maxAbsMove) * 100)).toFixed(2));
                      });
              }
              
              else if (viewStatistics === 'price') {
                    const prices = labels.map(d => {
                        const val = s.stock_data?.[d]?.close_price;
                        return val == null ? null : Number(val);
                    });

                    const firstPrice = prices.find(v => v != null);

                    if (!firstPrice) {
                        raw = [];
                    } else {

                      const pctMoves = prices.map(v => {
                          if (v == null) {
                              return null;
                          }
                          return (((v - firstPrice) / firstPrice) * 100);

                      });

                      const maxAbsMove = Math.max(
                          ...pctMoves
                              .filter(v => v != null)
                              .map(v => Math.abs(v)),
                          1
                      );
                      raw = pctMoves.map(v => {
                          if (v == null) {
                              return null;
                          }
                          return Number(Math.max(-100, Math.min(100, (v / maxAbsMove) * 100)).toFixed(2));
                      });

                      // console.log("pppp", raw)

                    }
                }else{
                    // raw = labels.map(d => {
                    //           const row = s.stock_data?.[d];
                    //           if (!row) 
                    //           return null;
                    //           const move = Number(row.change_per ?? 0);
                    //           const qty = Number(row.ttl_trd_qty ?? 0);
                    //           const trades = Math.max(Number(row.no_of_trades ?? 1), 1);
                    //           const delivery = Number(row.delivery_per ?? 0);
                    //           const marketCap = Number(row.marketcap ?? 0);
                    //           const avgTrade = qty / trades;
                    //           // local normalization
                    //           const qtyScore = Math.min(100, Math.log10(qty + 1) * 12);
                    //           const tradeScore = Math.min(100, avgTrade / labels.length);
                    //           const moveScore = normalize(Math.max(move, 0),  0, 12);
                    //           const accumulation = (qtyScore * .30 + tradeScore * .30 + delivery * .20 + moveScore * .20);
                    //           return Number(clamp(accumulation,  0, 100).toFixed(2));
                    //   });



                            const turnoverArr = labels.map(date => Number(s.stock_data?.[date]?.trunover_lacs)).filter(v => !isNaN(v));
                            const qtyArr = labels.map(date => Number(s.stock_data?.[date]?.ttl_trd_qty)).filter(v => !isNaN(v));
                            const tradeArr = labels.map(date => Number(s.stock_data?.[date]?.no_of_trades)).filter(v => !isNaN(v));
                            const deliveryArr = labels.map(date => Number(s.stock_data?.[date]?.delivery_per)).filter(v => !isNaN(v));

                            const avgTurnover = turnoverArr.length ? turnoverArr.reduce((a,b)=>a+b,0) / turnoverArr.length : 1;
                            const avgQty = qtyArr.length ? qtyArr.reduce((a,b)=>a+b,0) / qtyArr.length : 1;
                            const avgTrades = tradeArr.length ? tradeArr.reduce((a,b)=>a+b,0) / tradeArr.length : 1;
                            const avgDelivery = deliveryArr.length? deliveryArr.reduce((a,b)=>a+b,0) / deliveryArr.length : 1;

                            let accumulationCount = 0;

                            const accumulationSeries =
                                    labels.map((date, idx) => {

                                          const row = s.stock_data?.[date];
                                          if (!row) {
                                              return null;
                                          }

                                          const turnoverRatio = Number(row.trunover_lacs || 0) / Math.max(avgTurnover, 1);
                                          const qtyRatio = Number(row.ttl_trd_qty || 0) / Math.max(avgQty, 1);
                                          const tradeRatio = avgTrades / Math.max(Number(row.no_of_trades || 1), 1);
                                          const deliveryRatio = Number(row.delivery_per || 0 ) / Math.max(avgDelivery, 1);
                                          const isAccumulation =
                                                turnoverRatio > 1.20 &&
                                                qtyRatio > 1.10 &&
                                                tradeRatio > 0.55;

                                          if (isAccumulation) {
                                              accumulationCount++;
                                          }

                                          const score =
                                              turnoverRatio * 0.35 +
                                              qtyRatio * 0.25 +
                                              tradeRatio * 0.20 +
                                              deliveryRatio * 0.20;

                                    return score;

                                });

                                
                            // require minimum accumulation days 
                            if (accumulationCount <= Number(dataView === 'weekly' ? 2 : dataView === '2weekly'? 4: 7)) {
                                raw = [];
                            } else {
                                // console.log(accumulationCount, dataView)
                                const first = accumulationSeries.find(x => x != null) || 1;
                                const relative = accumulationSeries.map(v => {
                                        if (v == null) {
                                            return null;
                                        }
                                        return (((v - first) / first) * 100);
                                    });

                                const maxAbs = Math.max(...relative
                                            .filter(v => v != null)
                                            .map(v => Math.abs(v)),
                                        1
                                    );


                                    raw = relative.map(v => {
                                              if (v == null) {
                                                  return null;
                                              }
                                              return Number(Math.max(-100, Math.min(100, (v / maxAbs) * 100)).toFixed(2));
                                          });
                            }

        }

        const values = viewType === 'daily' ? raw : raw.map((v, idx) => {
              if (idx === 0 || v == null)
                return v;
              const prev = raw[idx - 1];
              if (prev == null)
                return v;
              return Number(clamp(prev * 0.20 + v * 0.80).toFixed(2));
          });

        // const finalValues = values.filter(v => v != null).every(v => v > (dataView === "weekly"? 65 : 52)) ? values : [];
        // const finalValues = viewStatistics === 'accumulation' ? (
        //     values.filter(v => v != null).every(v => v > (dataView === "weekly" ? 65 : 52)) ? values  : [] ) : values;

        const momentum = Number(s.momentum || 0);
        const normalizedMomentum = normalize(momentum, minMomentum, maxMomentum);
        const strength = Number(s.sectorStrength || 0);

        // recent move
        const latestMove = values.filter(v => v != null).at(-1) ?? 0;

        const latestNiftyMove = niftyBenchmark.filter(v => v != null).at(-1) ?? 0;
        const rsScore = Number((latestMove - latestNiftyMove).toFixed(2));
        const rsVelocity = Number((rsScore - ((values.filter(v => v != null).slice(-2, -1)[0] ?? 0) - (niftyBenchmark.slice(-2, -1)[0] ?? 0))).toFixed(2));

        // improved rotation score
        const rotationScore = Number(( (normalizedMomentum * 0.40) + (strength * 0.40) + (latestMove * 0.20)).toFixed(2));
        // const rotationScore = viewStatistics === 'score'? (normalizedMomentum * 0.25) + (strength * 0.25) + (latestMove * 0.20) + (rsScore * 0.20) + (rsVelocity * 0.10): (normalizedMomentum * 0.40) + (strength * 0.40) + (latestMove * 0.20);
        const isLeader = rotationScore >= 40 && normalizedMomentum >= 15 && strength >= 55;

        
        
        return {
              label: `${s.SECTOR.replace('NIFTY_', '')}` + (viewType === 'sector' && s.stock_count > 0 ? ` [${s.stock_count}]` : ''),
              symbol: `${s.SECTOR.replace('NIFTY_', '')}`,
              data: values,
              price:All_close_price,
              borderColor: generateColor(originalIndex),
              backgroundColor: generateColor(originalIndex),
              borderWidth: isLeader ? 3 : 2,
              tension: 0.25,
              pointRadius: isLeader ? 1 : 0,
              pointHoverRadius: 4,
              spanGaps: true,
              fill: false,
              order: -rotationScore,
              momentum,
              sectorStrength: strength,
              latestMove,
              rotationScore,
              isLeader,
              normalizedMomentum,
              datasetIndex: originalIndex,
              score: latestScore,
              current_star: current_star,
              close_price: close_price,
              delivery_per: delivery_per
      };

    })

    // sort AFTER score is computed
    .sort((a, b) => b.latestMove - a.latestMove);
    // .sort((a, b) => viewStatistics === 'score'?  b.rotationScore - a.rotationScore : b.latestMove - a.latestMove);

}, [sectors, labels, viewType, viewStatistics]);


  const datanifty = useMemo(() => {
         const clamp = (v, min = -100, max = 100) =>  Math.max(min, Math.min(max, Number(v || 0)));
         const momentumValues = getNiftyList.map(s => Number(s.momentum || 0));
         const minMomentum = Math.min(...momentumValues);
         const maxMomentum = Math.max(...momentumValues);

         return [...getNiftyList].map((s, originalIndex) => {

              let raw = [];
              
              if (viewStatistics === 'price') {
                    const prices = labels.map(d => {
                        const val = s.stock_data?.[d]?.close_price;
                        return val == null ? null : Number(val);
                    });

                    const firstPrice = prices.find(v => v != null);

                    if (!firstPrice) {
                        raw = [];
                    } else {

                      const pctMoves = prices.map(v => {
                          if (v == null) {
                              return null;
                          }
                          return (((v - firstPrice) / firstPrice) * 100);

                      });

                      const maxAbsMove = Math.max(
                          ...pctMoves
                              .filter(v => v != null)
                              .map(v => Math.abs(v)),
                          1
                      );
                      raw = pctMoves.map(v => {
                          if (v == null) {
                              return null;
                          }
                          return Number(Math.max(-100, Math.min(100, (v / maxAbsMove) * 100)).toFixed(2));
                      });

                      // console.log("pppp", raw)

                    }
                }else{
                    let indexValue = 100;

                    const relativeSeries = labels.map((d, idx) => {
                        if (idx === 0) {
                            return 0;
                        }
                        const change = Number(s.stock_data?.[d]?.change_per ?? 0);
                        // compounded movement
                        indexValue *= (1 + change / 100);
                        return (((indexValue - 100) / 100) * 100);
                    });

                    // find largest movement
                      const maxAbsMove = Math.max(
                          ...relativeSeries
                              .filter(v => v != null)
                              .map(v => Math.abs(v)),
                          1
                      );

                      // normalize to hierarchy
                      raw = relativeSeries.map(v => {
                          if (v == null) {
                              return null;
                          }
                          return Number(Math.max(-100, Math.min(100, (v / maxAbsMove) * 100)).toFixed(2));
                      });
                  }
                
                

        const values = viewType === 'daily' ? raw : raw.map((v, idx) => {
              if (idx === 0 || v == null)
                return v;
              const prev = raw[idx - 1];
              if (prev == null)
                return v;
              return Number(clamp(prev * 0.20 + v * 0.80).toFixed(2));
          });


        const momentum = Number(s.momentum || 0);
        const normalizedMomentum = normalize(momentum, minMomentum, maxMomentum);
        const strength = Number(s.sectorStrength || 0);

        // recent move
        const latestMove = values.filter(v => v != null).at(-1) ?? 0;

        const latestNiftyMove = niftyBenchmark.filter(v => v != null).at(-1) ?? 0;
        const rsScore = Number((latestMove - latestNiftyMove).toFixed(2));
        const rsVelocity = Number((rsScore - ((values.filter(v => v != null).slice(-2, -1)[0] ?? 0) - (niftyBenchmark.slice(-2, -1)[0] ?? 0))).toFixed(2));

        // improved rotation score
        const rotationScore = (normalizedMomentum * 0.40) + (strength * 0.40) + (latestMove * 0.20);
        // const rotationScore = viewStatistics === 'score'? (normalizedMomentum * 0.25) + (strength * 0.25) + (latestMove * 0.20) + (rsScore * 0.20) + (rsVelocity * 0.10): (normalizedMomentum * 0.40) + (strength * 0.40) + (latestMove * 0.20);
        const isLeader = rotationScore >= 40 && normalizedMomentum >= 15 && strength >= 55;

        

        return {
              label: s.SECTOR,
              symbol: s.SECTOR,
              data: values,
              borderColor: generateColor(originalIndex),
              backgroundColor: generateColor(originalIndex),
              borderWidth: isLeader ? 3 : 2,
              tension: 0.25,
              pointRadius: isLeader ? 1 : 0,
              pointHoverRadius: 4,
              spanGaps: true,
              fill: false,
              order: -rotationScore,
              momentum,
              sectorStrength: strength,
              latestMove,
              rotationScore,
              isLeader,
              normalizedMomentum,
              datasetIndex: originalIndex
      };

    })

   

    // sort AFTER score is computed
    .sort((a, b) => b.latestMove - a.latestMove);
    // .sort((a, b) => viewStatistics === 'score'?  b.rotationScore - a.rotationScore : b.latestMove - a.latestMove);

}, [sectors, labels, viewType, viewStatistics]);

const mergedDatasets = useMemo(() => {
  const dataNifty = datanifty[0]?.data || [];
  const sumLast3 = dataNifty.slice(-3).reduce((sum, item) => sum + Number(item || 0), 0);
  setNiftyBeats(sumLast3/3)
  

   return [
      ...datasets,
      ...datanifty
      .map(item => ({
         ...item,
         isNifty: true,
         borderColor: '#000000',
         backgroundColor: '#000000',
         borderWidth: 5,
         borderDash: [8, 5],
         pointRadius: 0,
         order: -9999
      }))
   ];



}, [datasets, datanifty]);

const chartData = {labels, datasets: mergedDatasets};
//datanifty
// const chartData = {labels, datasets};

const isMobile = window.matchMedia('(max-width: 575.98px)').matches;


const options = {
      responsive:true,
      animation: false,
      maintainAspectRatio:false,
      interaction:{
        mode:'nearest',
        intersect:false
      },
      layout:{
        padding:{
              right: isMobile ? 0 : 300,
              left: 0,
              top: 40,
              bottom: 0,
        }
      },
      plugins:{
          // rightLabelPlugin,
          legend:{
              display:false
          },
          tooltip: {
              enabled: true,
              backgroundColor: (context) => {
                      const tooltip = context.tooltip;
                      if (!tooltip || !tooltip.dataPoints || !tooltip.dataPoints.length) {
                          return '#111827';
                        }
                      return tooltip.dataPoints[0].dataset.backgroundColor;
              },

              displayColors: true,
              padding: 5,
              intersect: true,
              callbacks: {
                      title: (context) => {
                            return [
                              //  `${context[0].datasetIndex + 1}`,
                               `${context[0].dataset.label}` 
                              ];
                      },
                      label: (context) => {
                              //  console.log("tttttttttt", context);
                              const label = context.label;
                              const date = new Date(label);
                              const formattedDate =
                                `${String(date.getDate()).padStart(2, '0')}/${
                                  String(date.getMonth() + 1).padStart(2, '0')
                                }/${
                                  String(date.getFullYear()).slice(-4)
                                }`;
                                
                              // return dataView === 'daily'? label : formattedDate;

                              let indexPrice = sectors[context.datasetIndex]?.stock_data[context.label];
                              return [
                                  // context.dataset.label,
                                  `${dataView === 'daily'? label : formattedDate}`,
                                  `${indexPrice?.close_price != null? indexPrice.close_price : ''} (${context.raw}%)`
                              ];
                      },
              },
          },
      },
      scales:{
          x:{
            ticks: {
                color: '#6b7280',
                maxTicksLimit: 11,
                callback: function(value) {
                  const label = this.getLabelForValue(value);
                  const date = new Date(label);
                  const formattedDate =
                    `${String(date.getDate()).padStart(2, '0')}/${
                      String(date.getMonth() + 1).padStart(2, '0')
                    }/${
                      String(date.getFullYear()).slice(-2)
                    }`;
                    
                  return dataView === 'daily'? label : formattedDate;
                },
              },
                grid: {
                color: (ctx) => {
                    const value = ctx.tick?.value;
                    const label = ctx.chart.data.labels[value];
                    if (!label)
                        return '#e5e7eb';

                    const day = new Date(label).getDay();

                    // Monday = 1
                    return day === 5 ? '#666666' : '#e5e7eb';
                },

                lineWidth: (ctx) => {
                    const value = ctx.tick?.value;
                    const label = ctx.chart.data.labels[value];
                    if (!label)
                        return 1;
                    return new Date(label).getDay() === 1 ? 1.5 : 1;
                }

      },
          },
          y:{
            position:'right',
            ticks:{
              callback: v=> `${v}%`
            }
          }
      },
      onHover: (event, activeElements, chart) => {
                if(selectedSectorsName === "Select"){
                   const datasetIndex = activeElements?.length? activeElements[0].datasetIndex : null;
                   chart.$hoveredDataset = datasetIndex;

                    if (datasetIndex !== null) {
                            const ds = chart.data.datasets[datasetIndex];
                            const lineColor =   Array.isArray(ds.borderColor) ? ds.borderColor[0]  : ds.borderColor;
                            // setHoveredSymbol(
                            //     <span style={{color: lineColor }}> {`${ds.symbol} Rank [${datasetIndex + 1}]`} </span>
                            // );

                            setHoveredSymbol(prev => {
                                    const next = {
                                        text: `${ds.symbol} Rank [${datasetIndex + 1}]`,
                                        color: lineColor
                                    };

                                    if (prev?.key === `${next.text}-${next.color}`) {
                                        return prev;
                                    }

                                return (
                                    <span
                                        key={`${next.text}-${next.color}`}
                                        style={{color: next.color}}
                                    > {next.text}
                                    </span>
                                );
                            });

                            setSelectedSector(prev =>  Object.keys(prev || {}).length? {} : prev);
                    } else {
                        setHoveredSymbol(null);
                    }

                    chart.data.datasets.forEach((dataset, i) => {
                            if(dataset.label !== 'NIFTY_50'){
                                dataset.borderWidth = datasetIndex === i ? 6 : 2;
                            }
                           
                    });
                    chart.update('none');
            }
      },
      onClick: (event, activeElements, chart) => {
                  const datasetIndex = activeElements?.length? activeElements[0].datasetIndex : null;
                  const ds = chart.data.datasets[datasetIndex];
                  const symbol = ds.symbol

                  if(selectedSectorsName !=='Select' && symbol !=='NIFTY_50'){
                      getStockDetails({date: moment(startDate).format('YYYY-MM-DD'), stock: symbol}, userToken).then(res => {
                            setStocksDetails(res?.data?.data || [])
                            // console.log(res?.data?.data);
                      })
                      .catch(console.error)
                  }else{
                    handerSelectSector(symbol);
                  }

      }

      
};


 const selectedSectorList = useMemo(() => {
         const clamp = (v, min = -100, max = 100) =>  Math.max(min, Math.min(max, Number(v || 0)));
         const momentumValues = getSectorsList.map(s => Number(s.momentum || 0));
         const minMomentum = Math.min(...momentumValues);
         const maxMomentum = Math.max(...momentumValues);
        
         return [...getSectorsList].map((s, originalIndex) => {

          let indexValue = 100;

              const relativeSeries = labels.map((d, idx) => {
                  if (idx === 0) {
                      return 0;
                  }
                  const change = Number(s.stock_data?.[d]?.change_per ?? 0);
                  // compounded movement
                  indexValue *= (1 + change / 100);
                  return (((indexValue - 100) / 100) * 100);
              });

              // find largest movement
                const maxAbsMove = Math.max(
                    ...relativeSeries
                        .filter(v => v != null)
                        .map(v => Math.abs(v)),
                    1
                );

                // normalize to hierarchy
            const raw = relativeSeries.map(v => {
                    if (v == null) {
                        return null;
                    }
                    return Number(Math.max(-100, Math.min(100, (v / maxAbsMove) * 100)).toFixed(2));
                });

        // historical sector performance
        // const raw = labels.map(d => {
        //   const val = s.stock_data?.[d]?.change_per;
        //   return val == null ? null : clamp(val);
        // });

        const values = viewType === 'daily' ? raw : raw.map((v, idx) => {
              if (idx === 0 || v == null)
                return v;
              const prev = raw[idx - 1];
              if (prev == null)
                return v;
              return Number(clamp(prev * 0.20 + v * 0.80).toFixed(2));
          });

        const momentum = Number(s.momentum || 0);
        const normalizedMomentum = normalize(momentum, minMomentum, maxMomentum);
        const strength = Number(s.sectorStrength || 0);

        // recent move
        const latestMove = values.filter(v => v != null).at(-1) ?? 0;

        const latestNiftyMove = niftyBenchmark.filter(v => v != null).at(-1) ?? 0;
        const rsScore = Number((latestMove - latestNiftyMove).toFixed(2));
        const rsVelocity = Number((rsScore - ((values.filter(v => v != null).slice(-2, -1)[0] ?? 0) - (niftyBenchmark.slice(-2, -1)[0] ?? 0))).toFixed(2));

        // improved rotation score
        // const rotationScore = (normalizedMomentum * 0.40) + (strength * 0.40) + (latestMove * 0.20);
        const rotationScore = (normalizedMomentum * 0.40) + (strength * 0.60);
        // const rotationScore = viewStatistics === 'score'? (normalizedMomentum * 0.25) + (strength * 0.25) + (latestMove * 0.20) + (rsScore * 0.20) + (rsVelocity * 0.10): (normalizedMomentum * 0.40) + (strength * 0.40) + (latestMove * 0.20);
        const isLeader = rotationScore >= 40 && normalizedMomentum >= 15 && strength >= 55;

        return {
              symbol: `${s.SECTOR}`,
              data: values,
              momentum,
              sectorStrength: strength,
              latestMove,
              rotationScore,
              isLeader,
              normalizedMomentum,
              datasetIndex: originalIndex,
              score: 1
      };

    })

    // sort AFTER score is computed
    .sort((a, b) => b.rotationScore - a.rotationScore);
    // .sort((a, b) => viewStatistics === 'score'?  b.rotationScore - a.rotationScore : b.latestMove - a.latestMove);

}, [getSectorsList]);



// For Stocks 
// const datasetsforStocks = [...datasets]
//   .sort((a, b) => b.latestMove - a.latestMove)


const datasetsforStocks = [...datasets]
    .sort((a, b) => viewStatistics === 'accumulation'  ? (b.accumulation - a.accumulation) : (b.rotationScore - a.rotationScore));

// Current Top Rank
const top5Scores = [...datasets]
  .filter(s => {
      const momentum = Number(s.normalizedMomentum || 0);
      const strength = Number(s.sectorStrength || 0);
      const score = Number(s.rotationScore || 0);
      const latest = s.data?.filter(v => v != null)?.at(-1) ?? 0;
      return (
          latest > 60 &&
          score > 50 &&
          momentum > 20
      )
  })
  .sort((a, b) => viewStatistics === 'accumulation'  ? (b.accumulation - a.accumulation) : (b.sectorStrength - a.sectorStrength))
  .slice(0, 5);

// Confirmed Leaders

const top5Leaders = [...datasets]
  .filter(s => s.isLeader)
  .sort((a, b) => b.rotationScore - a.rotationScore)
  .slice(0, 5);


// Upcoming / Grooming sectors
const groomingSectors = [...datasets]
  .filter(s => {
      const momentum = Number(s.normalizedMomentum || 0);
      const strength = Number(s.sectorStrength || 0);
      const score = Number(s.rotationScore || 0);
      const latest = s.data?.filter(v => v != null)?.at(-1) ?? 0;
      return (
          // early trend
          momentum >= 8 && momentum < 20 &&
          // participation growing
          strength >= 35 && strength < 60 &&

          // not leader yet enough quality
          !s.isLeader && 
          score >= 20 && score <= 45 &&

          // recent price positive
          latest > 0


          // // emerging momentum
          // momentum >= 35 && momentum < 65 &&

          // // breadth improving
          // strength >= 40 && strength < 65 &&

          // // not confirmed leader and enough quality
          // !s.isLeader && score >= 40 && score < 60 &&

          // // actual recent participation
          // latest >= 1
      );
  })
  .sort((a, b) => b.rotationScore - a.rotationScore)
  .slice(0, 5);

  // Nifty Beats Stocks
  const StocksAboveNify = [...datasets].filter(s => {
      const last3 = s.data.slice(-3);
      // const price3 = s.price.slice(-3);
      const sumLast3 = last3.reduce((sum, item) => sum + Number(item || 0), 0);
      const avgLast3 = sumLast3 / last3.length;
      // const movePrice = price3[price3.length - 1] > price3[0];
      if(selectedSectorsName ==='Select'){
        return avgLast3 > niftyBeats 
      } else{
        return avgLast3 > niftyBeats && s.rotationScore > 50
      }
      
  }).sort((a, b) => b.rotationScore - a.rotationScore)
 // .slice(0, 7);

  

  const handleAsideSymbolClick = (symbol) => {
          const chart = chartRef.current;
          if (!chart) return;

         let selectedColor = "#555";
         let datasetIndex = 1;


        chart.data.datasets.forEach((ds, i) => {
            const isSelected = ds.symbol === symbol;
            if (isSelected) {
                datasetIndex = ds.datasetIndex + 1
                selectedColor = String( Array.isArray(ds.borderColor) ? ds.borderColor[0] : ds.borderColor  );
            }
            if(ds.symbol !== 'NIFTY_50'){
                  ds.borderWidth = isSelected ? 6 : 2;
                  ds.order = isSelected ? -999 : 1;
            }
            
            
        });
        chart.update();


        setHoveredSymbol(
            <span style={{ color: selectedColor}}>
                {`${symbol} Rank [${datasetIndex + 1}]`}
            </span>
        );

        // setHoveredSymbol(`${symbol} Rank [${datasetIndex + 1}]`);
        setSelectedSector({symbol, color: selectedColor});
        
  };

const handleLeadingSectors = (e, LeadingType, rotationScore, date) => {
    const { value, checked } = e.target;

    const selectedDate = moment(date).format('YYYY-MM-DD');

    setLeadingSectors(prev => {

        let updatedSectors;

        if (checked) {

            const alreadyExists = prev.some(
                item =>
                    item.value === value &&
                    item.LeadingType === LeadingType &&
                    item.date === selectedDate &&
                    item.view === viewType
            );

            updatedSectors = alreadyExists
                ? prev
                : [
                    ...prev,
                    {
                        value: value,
                        LeadingType: LeadingType,
                        rotationScore: rotationScore,
                        date: selectedDate,
                        view: viewType
                    }
                ];

        } else {

            updatedSectors = prev.filter(
                item =>
                    !(
                        item.value === value &&
                        item.LeadingType === LeadingType &&
                        item.date === selectedDate &&
                        item.view === viewType
                    )
            );
        }

        // For Save Sectors
        saveLeadingSectors({ leadingSectors: updatedSectors },  userToken)
        .then((res) => {
            // console.log("Saved:", res.data.leadingSectors);
        })
        .catch(console.error);

        return updatedSectors;
    });
};

const handleLeadingDropShow = () => {
    setLeadingDropShow(prev => !prev);
}

return (
<React.Fragment>
    <div className="pageContainer">
        <div className='container-fluid actionControler py-3'>
          <div className='row'>
            <div className="col-md-auto rotcont_width pe-md-0">
              <div className='form-floating'>
                <DatePicker 
                    placeholderText={'Select date'}
                    className="form-control"
                    id="viewDate"
                    selected={startDate} 
                    onChange={(date) => setStartDate(date)}
                    dateFormat="dd/MM/YYYY"
                    minDate={moment().subtract(20, "days")}
                    maxDate={getMaxDate}
                    filterDate={isWeekdayAllowed}
                />
                <label className='show' htmlFor="viewDate">Date</label>
              </div>
            </div>
            
            <div className='col-md-auto rotcont_width pe-md-0'>
              <div className='form-floating'>
                  <select className='form-control' id="viewType" defaultValue={viewType} onChange={(e)=> handleChangeViewType(e)}>
                    <option key={`vt_1`} value="indices">Indices</option>
                    <option key={`vt_2`} value="sector">Sector</option>
                    <option key={`vt_3`} value="combo">Combo</option>
                  </select>
                  <label htmlFor="viewType">View Type</label>
              </div>
            </div>

            <div className='col-md-auto rotcont_width pe-md-0'>
              <div className='form-floating'>
                  <select className='form-control' id="dataview" defaultValue={dataView} onChange={(e)=> handleChangeDataType(e)}>
                    {viewType !== 'combo'? <option key={`dv_1`} value="daily">Daily</option> :''}
                    <option key={`dv_2`} value="weekly">Weekly</option>
                    <option key={`dv_3`} value="2weekly">15 Days</option>
                    <option key={`dv_4`} value="monthly">Monthly</option>
                    {viewType !== 'combo'?<option key={`dv_5`} value="quarterly">Quarterly</option> :''}
                  </select>
                  <label htmlFor="dataview">Data View</label>
              </div>
            </div>

            <div className='col-md-auto rotcont_width pe-md-0'>
              <div className='form-floating'>                  
                        <select
                          className="form-control"
                          id="sectors"
                          value={selectedSectorsName}
                          onChange={e => handerSelectSector(e.target.value)}
                        >
                          <option value="Select">Select</option>
                          {selectedSectorList?.map((item, index) => {
                            // console.log(item)
                          return(
                            <option key={`sector_${index}`} value={`${item.symbol.replace('NIFTY_', '')}`}
                            style={{
                                    color: index < 5 ? 'rgb(0, 200, 60)' : '',
                                    fontWeight: index < 5 ? 'bold' : 'normal'
                                  }}
                            >
                              {String(index + 1).padStart(2, '0')}) {`${item.symbol.replace('NIFTY_', '')}`}
                            </option>
                          )})}
                        </select>
                        <label htmlFor="sectors">Sectors</label>

              </div>
            </div>

            {selectedSectorsName !== 'Select'?
            <>
            <div className='col-md-auto rotcont_width pe-md-0'>
              <div className='form-floating'>                  
                        <select
                          className="form-control r_stocks_list"
                          id="stocks"
                          // defaultValue={selectedSectorsName}
                          onChange={e => handerStockDetails(e.target.value)}
                        >
                          <option value="Select">Select</option>
                          {datasetsforStocks?.map((item, index) => {
                            return(
                            <option key={`stock_${index}`} value={item.symbol}
                            style={{
                                    color: index < 5 ? 'rgb(0, 200, 60)' : '',
                                    fontWeight: index < 5 ? 'bold' : 'normal'
                                  }}
                            >
                              {Number(item.current_star) === 1 ? '★  ' : '\u00A0\u00A0\u00A0\u00A0'}
                              {String(index + 1).padStart(2, '0')}) {item.symbol}
                            </option>
                          )})}
                        </select>
                        <label htmlFor="stocks">Stocks</label>

              </div>
            </div>

            {dataView !== 'daily'?
            <div className='col-md-auto rotcont_width pe-md-0'>
              <div className='form-floating'>
                  <select className='form-control' id="viewStatistics" value={viewStatistics} onChange={(e)=> setViewStatistics(e.target.value)}>
                    <option key={`vs_1`} value="change_per">Change Per</option>
                    <option key={`vs_2`} value="price">Price</option>          
                    {/* <option key={`vs_3`} value="score">Score</option>           */}
                    <option key={`vs_4`} value="accumulation">Accumulation</option>
                  </select>
                  <label htmlFor="viewStatistics">View Statistics</label>
              </div>
            </div>
            :''}
            </>
            :''}

            <div className='col-md-auto rotcont_width pe-md-0 position-relative'>
                <button className='form-control' onClick={handleLeadingDropShow}>Leading Sectors</button>
                <div className='LeadingSectorList' style={{display: leadingDropShow? "block":"none"}}>
                  {leadingSectorsList.map((group, index) => (
                      <div key={group[0]?.date || index}>
                          <h6>{moment(group[0]?.date).format("DD/MM/YYYY")}</h6>
                          <ul>
                              {group.map((sector, sectorIndex) => (
                                  <li key={`${sector.value}_${sector.LeadingType}_${sectorIndex}`}>
                                    <input
                                        name="LeadingSectors"
                                        value={sector.value}
                                        onChange={(e) => handleLeadingSectors(e, sector.LeadingType, sector.rotationScore, sector.date)}
                                        type="checkbox"                                                   
                                        checked={leadingSectors.some(item =>
                                                item.value === sector.value &&
                                                item.LeadingType === sector.LeadingType &&
                                                item.view === viewType
                                                // item.date === moment(startDate).format("YYYY-MM-DD")
                                        )}
                                    />
                                    <span>{sector.value}</span>
                                    <span>{sector.rotationScore}%</span>
                                    <span>{sector.view? ` [${sector.view.charAt(0).toUpperCase()}] ` : ""}{sector.LeadingType}</span>
                                  </li>
                              ))}
                          </ul>
                      </div>
                  ))}
                </div>
            </div>
            
          </div>
        </div>
        
          {
            (loader === true? <PageLoader />:           
              <div className='pagewrap canvasChart'>
                            { !loader &&
                              <>
                              <div className='chartsymbolName'>{hoveredSymbol !== 'undefined Rank [NaN]' ? hoveredSymbol : ""}</div>
                              
                              <Line
                                    ref={chartRef}
                                    data={chartData}
                                    options={{
                                      ...options,
                                      }}
                              />
                              
                              <ul className='selectedSectorName'>
                                
                                
                                 {getStocksDetails?.length > 0 && (

                                      <li style={{ fontWeight: 'bold', paddingTop: '10px' }}>
                                        <span>DETAILS</span> 
                                        <span onClick={() => setStocksDetails([])} style={{cursor:'pointer'}}>X</span>
                                        <div className={`SectorStockAcion action_details_id_${getStocksDetails[0].details_id}`}>
                                                <StockAction
                                                  symbol={getStocksDetails[0].symbol}
                                                  delivery={false}
                                                  currentPrice={getStocksDetails[0].close_price}
                                                  deliveryPer={getStocksDetails[0].delivery_per}
                                                  hotStar={getStocksDetails[0].hotStar}
                                                  myFev={getStocksDetails[0].myFev}
                                                  eventName={'Sector Rotation'}
                                                  slPrice={getStocksDetails[0].close_price * 0.96}
                                                  gttPrice={getStocksDetails[0].close_price * 1.04}
                                                  rowId={`stockDetail_1`}
                                                  score={getStocksDetails[0].score}
                                                  date={startDate}
                                                />
                                        </div>
                                      </li>
                                )}
                                 {
                                      getStocksDetails?.map((item, index) => {
                                        //console.log(item)
                                        let symbolName = item.symbol;
                                        let todayLTP = todayData?.find((s) => s.TICKER === symbolName);
                                        return (
                                            <>
                                          <li
                                            key={`leader_${index}`}
                                            className={selectedSector?.symbol === item.symbol? "active" : ""}
                                            style={{fontSize: '14px', color: selectedSector?.symbol === item.symbol? selectedSector?.color: ""}}
                                          > 
                                          
                                          <span style={{fontWeight:500}} onClick={() => handleAsideSymbolClick(item.symbol)}>{item.symbol}</span>
                                          
                                          {selectedSectorsName !=='Select'?
                                          <>
                                            <small>{item.score}%</small>
                                            <DeliveryGraph
                                                symbol={symbolName}
                                                todayLTP={todayLTP}
                                                date={moment(getDeliveryDate).format('YYYY-MM-DD')}
                                              />
                                            <span style={{width:'50px', height:'auto', display:'flex',  position:'relative'}}>
                                                <SectorPanchang
                                                  symbol={item.symbol}
                                                  sector={selectedSectorsName}
                                                  todayData={todayData}
                                                  symbolData={symbolData}
                                                  tag = "em"
                                                  align = "left"
                                                  durationDays = {durationDays}
                                                />
                                                <a
                                                  style={{marginLeft:'8px'}}
                                                  title="News"
                                                  className="newsicon"
                                                  href={`https://www.google.com/ai?q=${AIPromptForStock1(item.symbol)}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                ></a>
                                              </span>
                                            </>
                                            :
                                            <small>{item.rotationScore}%</small>                                            
                                            }
                                          </li>
                                          <li><StockDetails details={getStocksDetails[0]} ></StockDetails></li>
                                          </>
                                        );
                                      })
                                    }




                                {top5Leaders?.length > 0? <li style={{fontWeight:'bold', paddingTop:'10px'}}>LEADERS</li>:''}
                                    {
                                      top5Leaders?.map((item, index) => {
                                        let symbolName = item.symbol;
                                        let todayLTP = todayData?.find((s) => s.TICKER === symbolName);
                                        let details = symbolData?.find((s) => s.symbol === symbolName);
                                        return (
                                          <li
                                            key={`leader_${index}`}
                                            className={selectedSector?.symbol === item.symbol? "active" : ""}
                                            style={{color: selectedSector?.symbol === item.symbol? selectedSector?.color: ""}}
                                          > 
                                          <span onClick={() => handleAsideSymbolClick(item.symbol)}>{item.symbol}</span>
                                          {selectedSectorsName !=='Select'?
                                          <>
                                          <div className={`SectorStockAcionListing action_details_id_${details?.id}`}>
                                                <StockAction
                                                  symbol={item.symbol}
                                                  delivery={false}
                                                  currentPrice={item.close_price}
                                                  deliveryPer={item.delivery_per}
                                                  hotStar={details?.hotStar}
                                                  myFev={details?.myFev}
                                                  eventName={'Sector Rotation'}
                                                  slPrice={item.close_price * 0.96}
                                                  gttPrice={item.close_price * 1.04}
                                                  rowId={`top5Leaders_${index}`}
                                                  score = {item.score}
                                                  date={startDate}
                                                />
                                          </div>
                                            <small>{item.rotationScore}%</small>
                                            <DeliveryGraph
                                              symbol={symbolName}
                                              todayLTP={todayLTP}
                                              date={moment(getDeliveryDate).format('YYYY-MM-DD')}
                                            />
                                            <span style={{width:'50px', height:'auto', display:'flex'}}>
                                                <SectorPanchang
                                                  symbol={item.symbol}
                                                  sector={selectedSectorsName}
                                                  todayData={todayData}
                                                  symbolData={symbolData}
                                                  tag = "em"
                                                  align = "left"
                                                  durationDays = {durationDays}
                                                />
                                                <a
                                                  style={{marginLeft:'8px'}}
                                                  title="News"
                                                  className="newsicon"
                                                  href={`https://www.google.com/ai?q=${AIPromptForStock1(item.symbol)}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                ></a>
                                              </span>
                                            </>
                                            :
                                            <span className='checkbox_type' style={{width:'90px'}}>
                                              <small>{item.rotationScore}%</small>
                                              <span style={{width:'25px', height:'auto', marginLeft:'10px'}}>
                                              <SectorPanchang
                                                  symbol={''}
                                                  sector={item.symbol}
                                                  todayData={todayData}
                                                  symbolData={symbolData}
                                                  tag = "em"
                                                  align = "left"
                                                  durationDays = {durationDays}
                                                />
                                              </span>
                                              <input
                                                    style={{marginLeft:'7px'}}
                                                    name="LeadingSectors"
                                                    value={item.symbol}
                                                    onChange={(e) => handleLeadingSectors(e, "LEADERS", item.rotationScore, startDate)}
                                                    type="checkbox"                                                   
                                                    checked={leadingSectors.some(sector =>
                                                            sector.value === item.symbol &&
                                                            sector.LeadingType === "LEADERS" &&
                                                            sector.date === moment(startDate).format("YYYY-MM-DD") &&
                                                            sector.view === viewType
                                                    )}
                                                />
                                            </span>                                            
                                            }
                                          </li>
                                        );
                                      })
                                    }
                                    {top5Scores?.length > 0? <li style={{fontWeight:'bold', paddingTop:'10px'}}>TOP RANK</li>:''}
                                    {
                                      top5Scores?.map((item, index) => {
                                        // console.log(item)
                                        let symbolName = item.symbol;
                                        let todayLTP = todayData?.find((s) => s.TICKER === symbolName);
                                        let details = symbolData?.find((s) => s.symbol === symbolName);                                        
                                        return (
                                          <li
                                            key={`leader_${index}`}
                                            className={selectedSector?.symbol === item.symbol? "active" : ""}
                                            style={{color: selectedSector?.symbol === item.symbol? selectedSector?.color: ""}}
                                          > 
                                          <span onClick={() => handleAsideSymbolClick(item.symbol)}>{item.symbol}</span>
                                          {selectedSectorsName !=='Select'?
                                          <>
                                          <div className={`SectorStockAcionListing action_details_id_${details?.id}`}>
                                                <StockAction
                                                  symbol={item.symbol}
                                                  delivery={false}
                                                  currentPrice={item.close_price}
                                                  deliveryPer={item.delivery_per}
                                                  hotStar={details?.hotStar}
                                                  myFev={details?.myFev}
                                                  eventName={'Sector Rotation'}
                                                  slPrice={item.close_price * 0.96}
                                                  gttPrice={item.close_price * 1.04}
                                                  rowId={`top5Scores_${index}`}
                                                  score = {item.score}
                                                  date={startDate}
                                                />
                                          </div>
                                            <small>{item.rotationScore}%</small>
                                            <DeliveryGraph
                                                symbol={symbolName}
                                                todayLTP={todayLTP}
                                                date={moment(getDeliveryDate).format('YYYY-MM-DD')}
                                              />
                                            <span style={{width:'50px', height:'auto', display:'flex'}}>
                                                <SectorPanchang
                                                  symbol={item.symbol}
                                                  sector={selectedSectorsName}
                                                  todayData={todayData}
                                                  symbolData={symbolData}
                                                  tag = "em"
                                                  align = "left"
                                                  durationDays = {durationDays}
                                                />
                                                <a
                                                  style={{marginLeft:'8px'}}
                                                  title="News"
                                                  className="newsicon"
                                                  href={`https://www.google.com/ai?q=${AIPromptForStock1(item.symbol)}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                ></a>
                                              </span>
                                            </>
                                            :
                                            <span className='checkbox_type' style={{width:'90px'}}>
                                              <small>{item.rotationScore}%</small>
                                              <span style={{width:'25px', height:'auto', marginLeft:'10px'}}>
                                              <SectorPanchang
                                                  symbol={''}
                                                  sector={item.symbol}
                                                  todayData={todayData}
                                                  symbolData={symbolData}
                                                  tag = "em"
                                                  align = "left"
                                                  durationDays = {durationDays}
                                                />
                                              </span>
                                              <input
                                                    style={{marginLeft:'7px'}}
                                                    name="LeadingSectors"
                                                    value={item.symbol}
                                                    onChange={(e) => handleLeadingSectors(e, "TOP RANK", item.rotationScore, startDate)}
                                                    type="checkbox"
                                                    checked={leadingSectors.some(sector =>
                                                            sector.value === item.symbol &&
                                                            sector.LeadingType === "TOP RANK" &&
                                                            sector.date === moment(startDate).format("YYYY-MM-DD") &&
                                                            sector.view === viewType
                                                    )}
                                                    
                                                />
                                            </span> 
                                            }
                                          </li>
                                        );
                                      })
                                    }
                                    
                                    { groomingSectors?.length > 0? <li style={{fontWeight:'bold', paddingTop:'10px'}}>GROOMING</li>:''}
                                    {
                                      groomingSectors?.map((item, index) => {
                                        //console.log(item)
                                        let symbolName = item.symbol;
                                        let todayLTP = todayData?.find((s) => s.TICKER === symbolName);
                                        let details = symbolData?.find((s) => s.symbol === symbolName);
                                        return (
                                          <li
                                            key={`leader_${index}`}
                                            className={selectedSector?.symbol === item.symbol? "active" : ""}
                                            style={{color: selectedSector?.symbol === item.symbol? selectedSector?.color: ""}}
                                          > 
                                          <span onClick={() => handleAsideSymbolClick(item.symbol)}>{item.symbol}</span>
                                          {selectedSectorsName !=='Select'?
                                          <>
                                          <div className={`SectorStockAcionListing action_details_id_${details?.id}`}>
                                                <StockAction
                                                  symbol={item.symbol}
                                                  delivery={false}
                                                  currentPrice={item.close_price}
                                                  deliveryPer={item.delivery_per}
                                                  hotStar={details?.hotStar}
                                                  myFev={details?.myFev}
                                                  eventName={'Sector Rotation'}
                                                  slPrice={item.close_price * 0.96}
                                                  gttPrice={item.close_price * 1.04}
                                                  rowId={`groomingSectors_${index}`}
                                                  score = {item.score}
                                                  date={startDate}
                                                />
                                          </div>
                                          <small>{item.rotationScore}%</small>
                                          <DeliveryGraph
                                              symbol={symbolName}
                                              todayLTP={todayLTP}
                                              date={moment(getDeliveryDate).format('YYYY-MM-DD')}
                                            />
                                            <span style={{width:'50px', height:'auto', display:'flex'}}>
                                                <SectorPanchang
                                                  symbol={item.symbol}
                                                  sector={selectedSectorsName}
                                                  todayData={todayData}
                                                  symbolData={symbolData}
                                                  tag = "em"
                                                  align = "left"
                                                  durationDays = {durationDays}
                                                />
                                                <a
                                                  style={{marginLeft:'8px'}}
                                                  title="News"
                                                  className="newsicon"
                                                  href={`https://www.google.com/ai?q=${AIPromptForStock1(item.symbol)}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                ></a>
                                              </span>
                                            </>
                                            :
                                            <span className='checkbox_type' style={{width:'90px'}}>
                                              <small>{item.rotationScore}%</small>
                                              <span style={{width:'25px', height:'auto', marginLeft:'10px'}}>
                                              <SectorPanchang
                                                  symbol={''}
                                                  sector={item.symbol}
                                                  todayData={todayData}
                                                  symbolData={symbolData}
                                                  tag = "em"
                                                  align = "left"
                                                  durationDays = {durationDays}
                                                />
                                              </span>
                                              <input
                                                    style={{marginLeft:'7px'}}
                                                    name="LeadingSectors"
                                                    value={item.symbol}
                                                    onChange={(e) => handleLeadingSectors(e, "GROOMING", item.rotationScore, startDate)}
                                                    type="checkbox"
                                                    checked={leadingSectors.some(sector =>
                                                            sector.value === item.symbol &&
                                                            sector.LeadingType === "GROOMING" &&
                                                            sector.date === moment(startDate).format("YYYY-MM-DD") &&
                                                            sector.view === viewType
                                                    )}
                                                />
                                            </span> 
                                            }
                                          </li>
                                        );
                                      })
                                    }

                                    
                                    { StocksAboveNify?.length > 0? <li style={{fontWeight:'bold', paddingTop:'10px'}}>BEAT NIFTY50 [{StocksAboveNify?.length}]</li>:''}
                                    {
                                      StocksAboveNify?.map((item, index) => {
                                        // console.log(item)
                                        let symbolName = item.symbol;
                                        let todayLTP = todayData?.find((s) => s.TICKER === symbolName);
                                        let details = symbolData?.find((s) => s.symbol === symbolName);
                                        return (
                                          <li
                                            key={`leader_${index}`}
                                            className={selectedSector?.symbol === item.symbol? "active" : ""}
                                            style={{color: selectedSector?.symbol === item.symbol? selectedSector?.color: ""}}
                                          > 
                                          <span onClick={() => handleAsideSymbolClick(item.symbol)}>{item.symbol}</span>
                                          {selectedSectorsName !=='Select'?
                                          <>     
                                          <div className={`SectorStockAcionListing action_details_id_${details?.id}`}>
                                                <StockAction
                                                  symbol={item.symbol}
                                                  delivery={false}
                                                  currentPrice={item.close_price}
                                                  deliveryPer={item.delivery_per}
                                                  hotStar={details?.hotStar}
                                                  myFev={details?.myFev}
                                                  eventName={'Sector Rotation'}
                                                  slPrice={item.close_price * 0.96}
                                                  gttPrice={item.close_price * 1.04}
                                                  rowId={`StocksAboveNify_${index}`}
                                                  score = {item.score}
                                                  date={startDate}
                                                />
                                          </div>
                                                                               
                                            <small title={item.sectorStrength} style={{color: item.rotationScore > 60 && item.sectorStrength > 60 ? "rgb(16, 217, 6)":""}}>{item.rotationScore}%</small>
                                            <DeliveryGraph
                                                symbol={symbolName}
                                                todayLTP={todayLTP}
                                                date={moment(getDeliveryDate).format('YYYY-MM-DD')}
                                              />
                                            <span style={{width:'50px', height:'auto', display:'flex'}}>
                                              <SectorPanchang
                                                  symbol={item.symbol}
                                                  sector={selectedSectorsName}
                                                  todayData={todayData}
                                                  symbolData={symbolData}
                                                  tag = "em"
                                                  align = "left"
                                                  durationDays = {durationDays}
                                                />

                                                {/* <a target="_blank" href={`https://chartink.com/stocks-new?symbol=${item.symbol}`}><img src={chartIcon} style={{width:'22px', height:'15px'}} /></a> */}
                                                <a
                                                  style={{marginLeft:'8px'}}
                                                  title="News"
                                                  className="newsicon"
                                                  href={`https://www.google.com/ai?q=${AIPromptForStock1(item.symbol)}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                ></a>
                                              </span>
                                            </>
                                            : 
                                            <span className='checkbox_type' style={{width:'90px'}}>
                                              <small>{item.rotationScore}%</small>
                                              <span style={{width:'25px', height:'auto', marginLeft:'10px'}}>
                                              <SectorPanchang
                                                  symbol={''}
                                                  sector={item.symbol}
                                                  todayData={todayData}
                                                  symbolData={symbolData}
                                                  tag = "em"
                                                  align = "left"
                                                  durationDays = {durationDays}
                                                />
                                              </span>
                                              <input
                                                    style={{marginLeft:'7px'}}
                                                    name="LeadingSectors"
                                                    value={item.symbol}
                                                    onChange={(e) => handleLeadingSectors(e, "BEAT NIFTY50", item.rotationScore, startDate)}
                                                    type="checkbox"
                                                    checked={leadingSectors.some(sector =>
                                                            sector.value === item.symbol &&
                                                            sector.LeadingType === "BEAT NIFTY50" &&
                                                            sector.date === moment(startDate).format("YYYY-MM-DD") &&
                                                            sector.view === viewType
                                                    )}
                                                />
                                            </span> 
                                            }
                                          </li>
                                        );
                                      })
                                    }
                              </ul>
                              </>
                            }
              </div>
          
          )}
          
    </div>
</React.Fragment>
);

}